import { createBrowserRouter, Navigate } from 'react-router';
import { LoginPage } from './pages/login/LoginPage.js';
import { Enroll2FAPage } from './pages/setup2fa/Enroll2FAPage.js';
import { AppShell } from './components/layout/AppShell.js';
import { DashboardPage } from './pages/dashboard/DashboardPage.js';
import { CredentialsPage } from './pages/credentials/CredentialsPage.js';
import { AccountPage } from './pages/account/AccountPage.js';
import { UsersPage } from './pages/admin/UsersPage.js';
import { AuditLogPage } from './pages/admin/AuditLogPage.js';
import { SettingsPage } from './pages/admin/SettingsPage.js';
import { ToastProvider } from './components/ui/Toast.js';
import { StacksPage } from './pages/stacks/StacksPage.js';
import { StackDetailPage } from './pages/stacks/StackDetailPage.js';
import { DeploymentsPage } from './pages/deployments/DeploymentsPage.js';
import { DeploymentDetailPage } from './pages/deployments/DeploymentDetailPage.js';
import { DropletsPage } from './pages/infrastructure/DropletsPage.js';
import { DatabasesPage } from './pages/infrastructure/DatabasesPage.js';
import { SpacesPage } from './pages/infrastructure/SpacesPage.js';
import { LoadBalancersPage } from './pages/infrastructure/LoadBalancersPage.js';
import { FirewallsPage } from './pages/infrastructure/FirewallsPage.js';
import { DnsPage } from './pages/dns/DnsPage.js';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/setup-2fa', element: <Enroll2FAPage /> },
  {
    path: '/',
    element: (
      <ToastProvider>
        <AppShell />
      </ToastProvider>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'stacks', element: <StacksPage /> },
      { path: 'stacks/:id', element: <StackDetailPage /> },
      { path: 'deployments', element: <DeploymentsPage /> },
      { path: 'deployments/:id', element: <DeploymentDetailPage /> },
      { path: 'infrastructure/droplets', element: <DropletsPage /> },
      { path: 'infrastructure/databases', element: <DatabasesPage /> },
      { path: 'infrastructure/spaces', element: <SpacesPage /> },
      { path: 'infrastructure/load-balancers', element: <LoadBalancersPage /> },
      { path: 'infrastructure/firewalls', element: <FirewallsPage /> },
      { path: 'dns', element: <DnsPage /> },
      { path: 'credentials', element: <CredentialsPage /> },
      { path: 'account', element: <AccountPage /> },
      { path: 'admin/users', element: <UsersPage /> },
      { path: 'admin/audit-log', element: <AuditLogPage /> },
      { path: 'admin/settings', element: <SettingsPage /> },
    ],
  },
]);
